export default {
  async all(companyId, config = {}) {
    return await this.$get({
      url: `${this.$baseurl}/companies/expense/category/${companyId}`,
      headers: this.headers,
      ...config,
    });
  },
};
